import React from 'react';
import QRCode from 'qrcode.react';
const QR = function QR(props) {
    const { renderAs = 'canvas', value, ...rest } = props;
    return React.createElement(QRCode, Object.assign({ renderAs: renderAs, value: value }, rest));
};
export default QR;
